import { Button } from 'antd';
import styles from './AuthForm.module.scss';

interface AuthSubmitButtonProps {
  label: string;
  loading?: boolean;
}

export function AuthSubmitButton({ label, loading }: AuthSubmitButtonProps) {
  return (
    <Button
      type="primary"
      htmlType="submit"
      size="large"
      block
      loading={loading}
      className={styles.submitBtn}
    >
      {label}
    </Button>
  );
}
